import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

interface CardEmptyStateProps {
  title: string;
}

export const CardEmptyState = ({ title }: CardEmptyStateProps) => {
  return (
    <div className="flex h-full items-center justify-center">
      <Paragraph variant="body" className="text-muted-foreground">
        {title}
      </Paragraph>
    </div>
  );
};
